import { de, enUS, hi, ru, tr } from 'date-fns/locale'

import type { Locale } from 'date-fns'

declare const LOCALE: string | undefined

const DEFAULT_DATE_LOCALE_CODE = 'ru'

const dateLocales: Record<string, Locale> = {
  de,
  en: enUS,
  'en-us': enUS,
  hi,
  ru,
  'ru-ru': ru,
  tr,
}

const normalizeLocaleCode = (localeCode: string) => localeCode.toLowerCase().replace('_', '-')

export function getCurrentLocaleCode() {
  if (typeof LOCALE !== 'undefined' && LOCALE) {
    return normalizeLocaleCode(LOCALE)
  }

  if (typeof document !== 'undefined' && document.documentElement.lang) {
    return normalizeLocaleCode(document.documentElement.lang)
  }

  if (typeof navigator !== 'undefined' && navigator.language) {
    return normalizeLocaleCode(navigator.language)
  }

  return DEFAULT_DATE_LOCALE_CODE
}

export function getSupportedDateLocaleCode(localeCode = getCurrentLocaleCode()) {
  const normalizedLocaleCode = normalizeLocaleCode(localeCode)
  const languageCode = normalizedLocaleCode.split('-')[0]

  if (dateLocales[normalizedLocaleCode]) {
    return normalizedLocaleCode
  }

  return dateLocales[languageCode] ? languageCode : DEFAULT_DATE_LOCALE_CODE
}

export function getDateLocale(localeCode = getCurrentLocaleCode()) {
  return dateLocales[getSupportedDateLocaleCode(localeCode)]
}
